import { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';
import { MOBILE_MENU_EVENT } from '../../layout/Header/Header';

const WhatsAppButton = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleMenuChange = (e) => {
      setIsMenuOpen(Boolean(e.detail?.open));
    };

    window.addEventListener(MOBILE_MENU_EVENT, handleMenuChange);

    return () => {
      window.removeEventListener(MOBILE_MENU_EVENT, handleMenuChange);
    };
  }, []);

  if (isMenuOpen) {
    return null;
  }

  return (
    <div className="floating-whatsapp">
      <a
        href="https://wa.me/554999957692"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
        aria-label="Contatar via WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />

        <div className="tooltip">
          Fale conosco no WhatsApp
          <div className="tooltip-arrow-right"></div>
        </div>

        <div className="whatsapp-pulse"></div>
      </a>
    </div>
  );
};

export default WhatsAppButton;